import { useClientTerminology } from '@/views/list/NetworkTerms';
import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import type { FilterState } from '@/features/filterSlice';
import { InputSelect } from '@/components/InputSelect/InputSelect';
import type { PhaseType } from '@/features/types';

type PhaseName = PhaseType extends `${infer Prefix}-phase`
  ? `${Prefix}Phase`
  : never;

const transformToPhaseName = (phasing: PhaseType): PhaseName =>
  phasing.replace('-phase', 'Phase') as PhaseName;

export const PhaseFilters = ({
  phasingTypes,
  control,
}: {
  phasingTypes: PhaseType[];
  control: Control<FilterState>;
}) => {
  const intl = useClientTerminology();

  const options = phasingTypes.map((phasing) => {
    const name = transformToPhaseName(phasing);
    return {
      value: phasing,
      label: intl.formatMessage({
        id: `filter.${name}SpanTypeLabel`,
      }),
    };
  });

  return (
    phasingTypes.length > 0 && (
      <Controller
        name="phasingType"
        control={control}
        render={({ field: { onChange, onBlur, value } }) => (
          <InputSelect
            label={intl.formatMessage({ id: 'filter.phaseSystemLabel' })}
            options={options}
            isMulti={true}
            placeholder="All Phases"
            value={
              value
                ? options.filter((option) => value.includes(option.value))
                : []
            }
            onChange={onChange}
            onBlur={onBlur}
          />
        )}
      />
    )
  );
};
